enum ActionTypes {
    START_DRAG = "dragDrop/startDrag",
    END_DRAG = "dragDrop/endDrag"
}

export default ActionTypes;
